import Vue from 'vue'
import Router from 'vue-router'
import iDalgoDefault from '@/layouts/iDalgo-Default'
import iDalgoTemplates from '@/views/iDalgo-Templates'
import iDalgoTemplateNew from '@/views/iDalgo-Template-New'
import iDalgoTemplateEdit from '@/views/iDalgo-Template-Edit'
import iDalgo403 from '@/views/iDalgo-403'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/app',
      name: 'app',
      meta: { requiresAuth: true },
      redirect: { name: 'templates' },
      component: iDalgoDefault,
      children: [
        {
          path: 'templates',
          name: 'templates',
          component: iDalgoTemplates
        },
        {
          path: 'templates/new',
          name: 'newTemplate',
          component: iDalgoTemplateNew
        },
        {
          path: 'templates/:id',
          name: 'editTemplate',
          component: iDalgoTemplateEdit
        }
      ]
    },
    { path: '/', meta: { requiresAuth: true }, redirect: { name: 'templates' } },
    { path: '*', meta: { requiresAuth: true }, redirect: { name: 'templates' } },
    {
      path: '/403',
      name: 'forbidden',
      component: iDalgo403
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js